"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./Spinner.scss");
const Spinner_scss_json_1 = __importDefault(require("./Spinner.scss.json"));
function Spinner({ active = true }) {
    return (react_1.default.createElement("div", { className: [Spinner_scss_json_1.default.spinner, active && Spinner_scss_json_1.default.active].join(' '), role: "progressbar", "aria-busy": active ? 'true' : 'false' }));
}
exports.default = Spinner;
//# sourceMappingURL=Spinner.js.map